import React from "react";
import { createUseStyles } from "react-jss";
import classNames from "classnames";

const useStyles = createUseStyles((theme) => ({
	connectButton: {
		width: "210px",
		height: "40px",
		backgroundColor: theme.palette.colors.purplishBlue,
		borderRadius: "10px",
		cursor: "pointer",
		"& a": {
			height: "100%",
			width: "100%",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			fontSize: "14px",
			fontFamily: theme.fonts.medium,
			color: theme.palette.colors.white,
			letterSpacing: "2px",
			textTransform: "uppercase",
			paddingRight: "10px",
			textAlign: "center",
		},
		"& >div": {
			height: "100%",
			width: "100%",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			fontSize: "14px",
			fontFamily: theme.fonts.medium,
			color: theme.palette.colors.white,
			letterSpacing: "2px",
			textTransform: "uppercase",
			paddingRight: "10px",
			textAlign: "center",
		},
	},
	connectButtonRatesTag: {},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		connectButton: {
			width: "170px",
			"& a": {
				fontSize: "12px",
				paddingRight: 0,
			},
			"& >div": {
				fontSize: "12px",
				paddingRight: 0,
			},
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		connectButton: {
			width: "100%",
			height: "50px",
			borderRadius: "0 0 10px 10px",
			"& a": {
				fontSize: "12px",
				paddingRight: 0,
				letterSpacing: "1.71px",
			},
			"& >div": {
				fontSize: "12px",
				paddingRight: 0,
				letterSpacing: "1.71px",
			},
		},
		connectButtonRatesTag: {
			minHeight: "77px",
			height: "100%",
			borderRadius: "0 0 10px 0",
			"& a": {
				fontSize: "16px",
			},
			"& >div": {
				fontSize: "16px",
			},
		},
	},
}));

const Button = ({ onClickConnect, buttonConnectComponent, connectButtonDatatest, isRatesTag }) => {
	const classes = useStyles();
	return (
		<div
			className={classNames(classes.connectButton, {
				[classes.connectButtonRatesTag]: isRatesTag,
			})}
			onClick={() => !!onClickConnect && onClickConnect()}
			datatest={connectButtonDatatest}
		>
			{buttonConnectComponent}
		</div>
	);
};

export default Button;
